import { createFileRoute, redirect } from '@tanstack/react-router'
import { MainLayout } from '../components/MainLayout'
import { FlowPage } from '../pages/FlowPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/flow')({
  component: Flow,
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState()
    if (!isAuthenticated) {
      throw redirect({ to: '/login' })
    }
  },
})

function Flow() {
  return (
    <MainLayout>
      <FlowPage />
    </MainLayout>
  )
}
